//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      brandName: '',
      model: '',
      size: '',
      unit: '',
      buyNumber: 0,
      totalAmount: 0,
      orders: []
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  components: {
  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.pick(this.initialForm, 'beginTime', 'endTime', 'goodsId')
      // console.log('data', data)
      this.$axios.get('/mtea/store/admin/report/goodsOrderStatistics', {params: data}).then(res => {
        this.buyNumber = _.reduce(res.orders, (memo, item) => {
          return memo + item.buyNumber
        }, 0)
        this.totalAmount = _.reduce(res.orders, (memo, item) => {
          return memo + item.totalAmount
        }, 0)
        _.extend(this, res)
      }).finally(() => {
        this.loading = false
      })
    },
    handleOpen () {
      this.handleLoadTableData()
    },
    handleClose(){
      _.extend(this, _.omit(this.$options.data(), 'currentVisible','loading'))
    }
  }
}
